// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-locations-container .short{margin:0;padding:0;line-height:0}", ""]);
// Exports
module.exports = exports;
